import { Box, Flex, Text } from '@chakra-ui/react';
import { BrowserView, MobileView } from 'react-device-detect';
import { BrowserSidebar } from '../component/globalComponents/BrowserSidebar';
import { BrowserTopBar } from '../component/globalComponents/BrowserTopBar';
import { MobileFooter } from '../component/globalComponents/MobileFooter';

export const PrivacyAppendix = () => {
    const renderContent = () => (
        <Flex className={'privacy-policy'}>
            <h1>
                <strong>Privacy Appendix</strong>
            </h1>
            <div>
                <p>
                    This table summarizes our ad serving and analytics providers and where you can
                    go to get more information about their policies and practices and opt out of
                    their networks in many cases.
                </p>
            </div>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <span>PROVIDER</span>
                            </th>
                            <th>
                                <span>PRIVACY POLICY</span>
                            </th>
                            <th>
                                <span>OPT-OUT</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span>Apple Search Ads</span>
                            </td>
                            <td>
                                <a
                                    href="https://searchads.apple.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://searchads.apple.com/privac
                                </a>
                                <span>y</span>
                            </td>
                            <td>
                                <a
                                    href="https://support.apple.com/en-us/HT202074"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://support.apple.com/en-us/HT20207
                                </a>
                                <span>4</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Amazon</span>
                            </td>
                            <td>
                                <a
                                    href="https://www.amazon.ca/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://www.amazon.ca/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ
                                </a>
                            </td>
                            <td>
                                <a
                                    href="https://www.amazon.com/adprefs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://www.amazon.com/adprefs
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Facebook Network</span>
                            </td>
                            <td>
                                <a
                                    href="https://www.facebook.com/privacy/explanation"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://www.facebook.com/privacy/explanation
                                </a>
                            </td>
                            <td>
                                <span>N/A</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Facebook Insights</span>
                            </td>
                            <td>
                                <a
                                    href="https://www.facebook.com/about/privacy/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://www.facebook.com/about/privacy
                                </a>
                                <span>/</span>
                            </td>
                            <td>
                                <span>N/A</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Google</span>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/privacy
                                </a>
                            </td>
                            <td>
                                <a
                                    href="https://optout.networkadvertising.org/?c=1#!%252F"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://optout.networkadvertising.org/?c=1#!%2
                                </a>
                                <span>F</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Google Analytics</span>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/privacy
                                </a>
                            </td>
                            <td>
                                <a
                                    href="https://tools.google.com/dlpage/gaoptout?hl=en"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://tools.google.com/dlpage/gaoptout?hl=en
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Google Apps</span>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/privacy
                                </a>
                            </td>
                            <td>
                                <a
                                    href="http://www.google.com/settings/ads"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    http://www.google.com/settings/ads
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Google Ads Data Hub (ADH)</span>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/privac
                                </a>
                                <span>y</span>
                            </td>
                            <td>
                                <a
                                    href="https://tools.google.com/dlpage/gaoptout?hl=en"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://tools.google.com/dlpage/gaoptout?hl=e
                                </a>
                                <span>n</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Google Mobile Ads</span>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/privacy"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/privacy
                                </a>
                            </td>
                            <td>
                                <a
                                    href="https://policies.google.com/technologies/ads"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://policies.google.com/technologies/ads
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Microsoft</span>
                            </td>
                            <td>
                                <a
                                    href="https://privacy.microsoft.com/en-US/privacystatement"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://privacy.microsoft.com/en-US/privacystatement
                                </a>
                            </td>
                            <td>
                                <a
                                    href="https://optout.networkadvertising.org/?c=1#!%252F"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://optout.networkadvertising.org/?c=1#!%2
                                </a>
                                <span>F</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Flex>
    );

    return (
        <>
            <BrowserView>
                <BrowserTopBar isLoading={false}>
                    <Box className={'settings-title browser-view-title'}>
                        <Text>PRIVACY</Text>
                    </Box>
                </BrowserTopBar>
                <BrowserSidebar />
                <Flex className={'browser-content'}>{renderContent()}</Flex>
            </BrowserView>
            <MobileView>
                <Box className={'mobile-container'}>
                    <Box className={'settings-title mobile-title-bar'}>
                        <Text>PRIVACY</Text>
                    </Box>
                    <Flex className={'privacy-mobile'}>{renderContent()}</Flex>
                    <MobileFooter />
                </Box>
            </MobileView>
        </>
    );
};
